import React, { useEffect, useState } from "react"

export default function HorasTotales({ horas, horasSemana, indHoy }) {

    const [widthSemana, setWidthSemana] = useState("20px")
    useEffect(() => {
        setWidthSemana((document.getElementById("HThoras").offsetWidth / horas.length).toString() + "px")
    }, [horas.length])

    return (
        <div style={ShorasIncidentes} id="HThoras">

            <div style={{ position: "relative" }}>
                <div style={Splan}></div>
                <div style={Shoras} >
                    {horas.map((h, ind) => (
                        <div style={{ background: h ? "#212121" : "", height: (Math.min(h * 7 / horasSemana, 7)).toString() + "vh", width: widthSemana, opacity: (indHoy === -2 || ind < indHoy) ? 0.9 : 0.7, borderBottom: (h > horasSemana) ? "solid 2px red" : "" }} key={ind}
                            onMouseOver={(e) => (e.currentTarget.style.color = "white")}
                            onMouseLeave={(e) => (e.currentTarget.style.color = "transparent")}>
                            {h}
                        </div>)
                    )}
                </div>
            </div>

        </div>
    )
}

const ShorasIncidentes = {
    position: "relative",
    paddingBottom: "15px"
}

const Shoras = {
    display: "flex",
    flexDirection: "row",
    color: "transparent",
    fontSize: "1.8vh",
    fontWeight: 500,
    height: "7vh"
}

const Splan = {
    position: "absolute",
    border: "1px solid #e6e6e6",
    width: "100%",
    height: "7vh",
}